import styled from 'styled-components';

import { Container } from 'components/utilities/pageStyles';

export const LandingPageContainer = styled(Container)<{
  backgroundGradient: string;
  hasBackgroundGradient: boolean;
}>`
  background: ${({ hasBackgroundGradient, backgroundGradient }) =>
    hasBackgroundGradient ? backgroundGradient : 'unset'};
  background-size: 100% 952px;
  background-repeat: no-repeat;
`;

export const LandingPageExtraLargeStyling = styled.div<{
  forceExtraLargeStyling: boolean;
}>`
  ${({ forceExtraLargeStyling }) =>
    forceExtraLargeStyling
      ? `h1 {
  font-size: 62px;
  line-height: 64px;
  font-weight: 800;

  @media only screen and (max-width: 600px) {
    font-size: 42px;
  }
  @media only screen and (max-width: 600px) {
    line-height: 46px;
  }
}

h2 {
  font-weight: 800;
  font-size: 36px;
  line-height: 40px;

  @media only screen and (max-width: 600px) {
    font-size: 28px;
  }
  @media only screen and (max-width: 600px){
    line-height: 36px;
  }
}`
      : ``}
`;
